module.exports = __webpack_public_path__ + "img/Weapon_245.2705546d.png";